var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
        _c("p", [
          _vm._v(
            "注意:上传文件中，不要放置宏或图标，不要更改列的顺序，数据中不要使用公式。。"
          ),
        ]),
        _vm._v(" "),
        _c("a", { on: { click: _vm.downloadModel } }, [_vm._v("(下载模板)")]),
      ]),
      _vm._v(" "),
      _c("button", { on: { click: _vm.fileClick } }, [_vm._v("选择文件")]),
      _vm._v("  " + _vm._s(_vm.fileName) + "\n  "),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file" },
        on: { change: _vm.fileChange },
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticStyle: { float: "right" }, on: { click: _vm.uploadFile } },
        [_vm._v("确认上传")]
      ),
      _vm._v(" "),
      _vm.spinShow
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }